const releaseYear = import.meta.env.VITE_APP_RELEASE_YEAR || new Date().getFullYear()

export const copyrightYear = () => {
  if (new Date().getFullYear() !== Number(releaseYear)) {
    return releaseYear + '-' + new Date().getFullYear()
  }

  return releaseYear
}
